import Breadcrumb from '../components/Breadcrumb'

const Cookies = () => {
  const breadcrumbItems = [
    { label: 'Home', path: '/' },
    { label: 'Cookies Policy' }
  ]

  return (
    <div className="min-h-screen bg-white">
      {/* Header Section */}
      <section className="bg-gradient-to-r from-dark-background to-dark-plum text-white py-12">
        <div className="container-custom">
          <Breadcrumb
            items={breadcrumbItems}
            className="mb-6 text-gray-300"
          />
          <div className="max-w-3xl">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-white">
              Cookies Policy
            </h1>
            <p className="text-xl text-gray-200">
              How we use cookies on our website to enhance your experience
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <div className="space-y-8">

              <div>
                <h2 className="text-2xl font-semibold text-dark-plum mb-4">What are cookies?</h2>
                <p className="text-gray-600 mb-4">
                  Cookies are small text files that are placed on your computer or mobile device when you visit a website.
                  They are widely used to make websites work more efficiently and provide information to website owners.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-dark-plum mb-4">How we use cookies</h2>
                <p className="text-gray-600 mb-4">
                  We use cookies to enhance your browsing experience, analyze website traffic, and provide personalised
                  content. Our cookies help us understand how you use our website so we can improve our services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-dark-plum mb-4">Types of cookies we use</h2>

                <div className="space-y-6">
                  <div className="border-l-4 border-primary-green pl-6">
                    <h3 className="text-xl font-semibold text-dark-plum mb-2">Essential Cookies</h3>
                    <p className="text-gray-600 mb-2">
                      These cookies are necessary for the website to function properly. They enable basic functions like
                      page navigation and access to secure areas of the website.
                    </p>
                    <p className="text-sm text-gray-500">
                      <strong>Examples:</strong> Session management, form submissions, security features
                    </p>
                  </div>

                  <div className="border-l-4 border-primary-green pl-6">
                    <h3 className="text-xl font-semibold text-dark-plum mb-2">Analytics Cookies</h3>
                    <p className="text-gray-600 mb-2">
                      These cookies help us understand how visitors interact with our website by collecting and
                      reporting information anonymously.
                    </p>
                    <p className="text-sm text-gray-500">
                      <strong>Examples:</strong> Google Analytics, page visit tracking, user behavior analysis
                    </p>
                  </div>

                  <div className="border-l-4 border-primary-green pl-6">
                    <h3 className="text-xl font-semibold text-dark-plum mb-2">Functionality Cookies</h3>
                    <p className="text-gray-600 mb-2">
                      These cookies remember your preferences and choices to provide enhanced functionality
                      and personalization.
                    </p>
                    <p className="text-sm text-gray-500">
                      <strong>Examples:</strong> Language preferences, form data, user interface customization
                    </p>
                  </div>

                  <div className="border-l-4 border-primary-green pl-6">
                    <h3 className="text-xl font-semibold text-dark-plum mb-2">Third-Party Cookies</h3>
                    <p className="text-gray-600 mb-2">
                      Some cookies are set by third-party services that appear on our pages, including embedded
                      content and quote forms.
                    </p>
                    <p className="text-sm text-gray-500">
                      <strong>Examples:</strong> Social media embeds, payment processors
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-dark-plum mb-4">Cookie consent</h2>
                <p className="text-gray-600 mb-4">
                  When you first visit our website, we'll ask for your consent to use cookies that are not essential
                  for the website to function. You can change your cookie preferences at any time.
                </p>
                <p className="text-gray-600 mb-4">
                  Essential cookies cannot be disabled as they are necessary for the website to work properly.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-dark-plum mb-4">Managing your cookies</h2>
                <p className="text-gray-600 mb-4">
                  Most web browsers allow you to control cookies through their settings preferences. You can:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
                  <li>View what cookies have been set and delete them individually</li>
                  <li>Block third-party cookies</li>
                  <li>Block cookies from particular sites</li>
                  <li>Accept cookies and then be notified when websites try to set them</li>
                  <li>Delete all cookies when you close your browser</li>
                </ul>
                <p className="text-gray-600 mb-4">
                  Please note that deleting or blocking cookies may impact your user experience and some
                  website functionality may not work as expected.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-dark-plum mb-4">Browser-specific instructions</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-dark-plum mb-2">Chrome</h4>
                    <p className="text-sm text-gray-600">
                      Settings → Privacy and security → Cookies and other site data
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-dark-plum mb-2">Firefox</h4>
                    <p className="text-sm text-gray-600">
                      Options → Privacy & Security → Cookies and Site Data
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-dark-plum mb-2">Safari</h4>
                    <p className="text-sm text-gray-600">
                      Preferences → Privacy → Manage Website Data
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-dark-plum mb-2">Edge</h4>
                    <p className="text-sm text-gray-600">
                      Settings → Cookies and site permissions → Cookies and site data
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-dark-plum mb-4">Updates to this policy</h2>
                <p className="text-gray-600 mb-4">
                  We may update this Cookies Policy from time to time. When we do, we'll post the updated
                  policy on this page and update the "last updated" date below.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-semibold text-dark-plum mb-4">Contact us</h2>
                <p className="text-gray-600 mb-4">
                  If you have any questions about our use of cookies, please contact us:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="text-gray-600 mb-2">
                    <strong>Email:</strong> {import.meta.env.VITE_COMPANY_CONTACT_EMAIL}
                  </p>
                  <p className="text-gray-600 mb-2">
                    <strong>Phone:</strong> {import.meta.env.VITE_COMPANY_PHONE}
                  </p>
                  <p className="text-gray-600">
                    <strong>Address:</strong> {import.meta.env.VITE_COMPANY_ADDRESS}
                  </p>
                </div>
              </div>

              <div className="border-t pt-6">
                <p className="text-sm text-gray-500">
                  <strong>Last updated:</strong> 23 April 2026
                </p>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Cookies